import { render } from "./LayersIcon.vue?vue&type=template&id=6141cd27"
import script from "./LayersIcon.vue?vue&type=script&lang=js"
export * from "./LayersIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__